import React, { useEffect, useRef, useState, useCallback } from "react";
import Alert from "react-bootstrap/Alert";
import { FaPrint, FaRedo } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { useReactToPrint } from "react-to-print";
import Logo from "../../assets/img/Daimler_Logo_Text.png";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, Row, Col } from "react-bootstrap";
import { DialogActions, DialogContentText } from "@mui/material";
import { apiService } from "../../services/apiClient";
import { apiUrl } from "../../services/apiUrl";
import Select from "react-select";
import preloadimg from "../../assets/img/preloader1.gif";
import Exportuserlist from "../layout/Exportuserlist";
import AppButton from "../layout/AppButton";
import UserTable, { UserTableSkeleton } from "../layout/UserTable";
import { useUserAdmin } from "../../hooks/useUserAdmin";
import { useRoleAdmin } from "../../hooks/useRoleAdmin";

const UserManagement = ({ passtoken }) => {
  const [isLoading, setIsloading] = useState(true);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const currentPagelimit = 20;
  const [userType, setUsertype] = useState("");
  const [userGroup, setUserGroup] = useState("");
  const [Deleteinguser, setDeleteinguser] = useState(false);
  const [userinfo, setuserinfo] = useState([]);

  // Update form state
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [UpdateisLoading, setUpdateisLoading] = useState(false);
  const [UpdateuserType, setUpdateuserType] = useState("");
  const [EmailAdress, setEmail] = useState("");
  const [selectedOptionsPersona, setselectedOptionsPersona] = useState([]);
  const [selectedPersona1, setselectedPersona1] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsDataRl, setselectedOptionsDataRl] = useState([]);
  const [ResetUpdateuserType, setResetUpdateuserType] = useState("");
  const [ResetselectedOptionsPersona, setResetselectedOptionsPersona] = useState([]);

  // Delete popup
  const [isDelete, setisDelete] = useState(false);
  const [deleteUserEmail, setdeleteUserEmail] = useState("");
  const [Deleteissuccess, setDeleteissuccess] = useState(false);

  const [userGroupMap, setUserGroupMap] = useState({});
  const [roleOptions, setRoleOptions] = useState([]);

  const componentRef_1 = useRef(null);
  const email = localStorage.getItem("myemail");

  const { users, loading: userLoading, fetchUsers } = useUserAdmin();
  const { roles, fetchRoles } = useRoleAdmin();

  const personaOptions = Object.entries(userGroupMap).map(([id, name]) => ({
    value: Number(id),
    label: name,
  }));

  useEffect(() => {
    if (!passtoken) return;
    fetchUsers();
    fetchRoles();
  }, [passtoken, fetchUsers, fetchRoles]);

  // Fetch the full persona/user-group list so newly created groups (with no
  // users assigned yet) still show up in the assignment dropdown & filter.
  useEffect(() => {
    if (!passtoken) return;
    apiService
      .get(apiUrl.personaUserGroups())
      .then((response) => {
        const groups = response.data?.data || [];
        const map = {};
        groups.forEach((g) => {
          if (g.id) map[g.id] = g.name;
        });
        setUserGroupMap((prev) => ({ ...prev, ...map }));
      })
      .catch(() => {});
  }, [passtoken]);

  useEffect(() => {
    if (!users || users.length === 0) return;
    setUserGroupMap((prev) => {
      const map = { ...prev };
      users.forEach((user) => {
        if (Array.isArray(user.userGroup)) {
          user.userGroup.forEach((g) => {
            if (g.userGroupId && g.userGroupName && !map[g.userGroupId]) {
              map[g.userGroupId] = g.userGroupName;
            }
          });
        }
      });
      return map;
    });
  }, [users]);

  useEffect(() => {
    if (!roles || roles.length === 0) return;
    setRoleOptions(roles.map((r) => ({ value: r.roleName || r.name, label: r.roleName || r.name })));
  }, [roles]);

  const fetchSearchByname = useCallback(() => {
    setuserinfo(users || []);
    setIsloading(userLoading);
  }, [users, userLoading]);

  useEffect(() => {
    fetchSearchByname();
  }, [users, userLoading, fetchSearchByname]);

  const sortedAsc = userinfo === null ? "" : userinfo.slice(0).sort((a, b) =>
    b.lastUpdateDateTime.localeCompare(a.lastUpdateDateTime)
  );

  const search_parameters = ["emailAddress", "createdBy"];
  const filter_by_userType = [...new Set(userinfo.map((item) => item.userType))];
  // Sourced from the full persona/user-group list, not just users currently loaded,
  // so newly created groups with no users yet still appear in the filter.
  const userGroupName = Object.keys(userGroupMap).map(Number).sort((a, b) => a - b);

  let filteredData = sortedAsc ? sortedAsc.filter((obj) => obj) : [];

  const handlePageChange = ({ selected }) => setCurrentPage(selected);

  function search() {
    return filteredData.filter(
      (item) =>
        item.userType.includes(userType) &&
        (!userGroup || item.userGroup.some((g) => g.userGroupId === parseInt(userGroup))) &&
        search_parameters.some((p) => item[p].toString().toLowerCase().includes(query.toLowerCase()))
    );
  }

  const printSegment = useReactToPrint({
    content: () => {
      const tableStat_1 = componentRef_1.current.cloneNode(true);
      const PrintElem = document.createElement("div");
      PrintElem.innerHTML = `<img src="${Logo}" style="padding-bottom:2rem" alt="logo" class="watermark"/>`;
      PrintElem.appendChild(tableStat_1);
      return PrintElem;
    },
  });

  const pageCount = Math.ceil(search().length / currentPagelimit);
  const currentData = search().slice((currentPage - 1) * currentPagelimit, currentPage * currentPagelimit);

  const handelepageclick = (data) => setCurrentPage(data.selected + 1);
  const resetAll = () => { setQuery(""); setUserGroup(""); setUsertype(""); setCurrentPage(1); };

  const getUserDetail = (emailAddr, usersGroup, usersType, RLType) => {
    setOpen(true);
    const transformedArray = usersGroup.map((item) => ({
      value: item.userGroupId,
      label: item.userGroupName || userGroupMap[item.userGroupId] || String(item.userGroupId),
    }));
    const transformedArrayRL = RLType.map((item) => ({ value: item.RLtypename, label: item.RLtypename }));
    setUpdateuserType(usersType);
    setEmail(emailAddr);
    setselectedOptionsPersona(transformedArray);
    setResetselectedOptionsPersona(transformedArray);
    setResetUpdateuserType(usersType);
    setSelectedOptions(transformedArrayRL);
    setselectedPersona1(usersGroup.map((g) => ({ userGroupId: g.userGroupId })));
    setselectedOptionsDataRl(RLType.map((r) => ({ RLtypename: r.RLtypename })));
  };

  const handleClose = (e) => { e.preventDefault(); setOpen(false); setValidated(false); };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!event.currentTarget.checkValidity()) return;
    setValidated(true);
    setUpdateisLoading(true);
    const data = { emailAddress: EmailAdress, userType: UpdateuserType, userGroup: selectedPersona1, rlType: selectedOptionsDataRl, assignUser: email };
    apiService.post(`${process.env.REACT_APP_SERVER_URL}/aipd/updateUser`, data)
      .then((response) => {
        if (response.status === 200) {
          fetchUsers();
          setUpdateisLoading(false);
          setValidated(false);
          setsuccess(true);
          setTimeout(() => setsuccess(false), 10000);
          seterror(false);
          setOpen(false);
        }
      })
      .catch(() => {
        setUpdateisLoading(false);
        setValidated(false);
        setsuccess(false);
        seterror(true);
        setTimeout(() => seterror(false), 10000);
      });
    setValidated(true);
  };

  const resetForm = (e) => { e.preventDefault(); setValidated(false); setselectedOptionsPersona(ResetselectedOptionsPersona); setUpdateuserType(ResetUpdateuserType); };
  const isDeleteUser = (emailAddr) => { setdeleteUserEmail(emailAddr); setisDelete(!isDelete); };

  const deleteusersinfo = () => {
    setisDelete(false);
    setDeleteinguser(true);
    apiService.post(`${process.env.REACT_APP_SERVER_URL}/aipd/deleteUser`, { emailAddress: deleteUserEmail })
      .then(() => {
        setDeleteissuccess(true);
        setDeleteinguser(false);
        fetchUsers();
        setTimeout(() => setDeleteissuccess(false), 5000);
      })
      .catch(() => setDeleteinguser(false));
  };

  const handleChangePersona = (opts) => {
    setselectedOptionsPersona(opts);
    setselectedPersona1(opts.map((o) => ({ userGroupId: o.value })));
  };

  const handleChange = (opts) => {
    setSelectedOptions(opts);
    setselectedOptionsDataRl(opts.map((o) => ({ RLtypename: o.value })));
  };

  return (
    <div id="Create_users_id">
      <div className="wrapper">
        {/* Toolbar */}
        <div style={{ paddingBottom: "0rem" }} className="searchBarSections">
          <div style={{ display: "flex", gridGap: "10px", alignContent: "center", alignItems: "center", position: "absolute", right: "30px", top: "30px" }}>
            <Exportuserlist excelData={search()}  fileName={`user_details_${new Date().getTime()}`} title="Export" />
            <AppButton onClick={printSegment}  variant="outline"  title="Print" icon={<FaPrint/>} >Print</AppButton>
            <AppButton onClick={fetchUsers}  variant="outline" title="Refresh" icon={<FaRedo/>}>Refresh</AppButton>
          </div>
        </div>

        {/* Filters */}
        <div style={{ display: "flex", paddingBottom: "0rem", justifyContent: "space-between", flexWrap: "wrap", gridGap: "10px" }}>
          <div style={{ width: "30%" }} className="search-wrapper">
            <input type="search" autoComplete="off" value={query} className="SearchBox_new" placeholder="Search for Email, Assigned By"
              onChange={(e) => { setQuery(e.target.value); handlePageChange({ selected: 1 }); }} />
          </div>
          <div style={{ display: "flex", gridGap: "20px" }}>
            <div className="selectParent select">
              <select value={userType} onChange={(e) => { setUsertype(e.target.value); handlePageChange({ selected: 1 }); }} className="custom-select">
                <option value="">Filter by User Type</option>
                {filter_by_userType.map((item, i) => <option key={i} value={item}>{item}</option>)}
              </select>
              <span className="focus"></span>
            </div>
            <div className="selectParent select">
              <select value={userGroup} onChange={(e) => { setUserGroup(e.target.value); handlePageChange({ selected: 1 }); }} className="custom-select">
                <option value="">Filter by User Group</option>
                {userGroupName.map((item, i) => <option key={i} value={item}>{userGroupMap[item] || String(item)}</option>)}
              </select>
              <span className="focus"></span>
            </div>
            <AppButton variant="outline" title="Refresh" icon={<FaRedo />} onClick={resetAll} />
          </div>
        </div>

        {/* Count + Pagination */}
        <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "1rem", paddingTop: "1rem" }}>
          <div style={{ fontSize: "18px", paddingBottom: "1rem", paddingTop: "1rem" }}>
            Total number of Users: <span style={{ fontSize: "18px", fontWeight: "600" }}>{search().length}</span>
          </div>
          <ReactPaginate previousLabel={"Previous"} nextLabel={"Next"} breakLabel={"..."} pageCount={pageCount}
            marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handelepageclick}
            containerClassName={"pagination"} pageClassName={"page-item"} pageLinkClassName={"page-link"}
            previousClassName={"page-item"} previousLinkClassName={"page-link"} nextClassName={"page-item"}
            nextLinkClassName={"page-link"} breakClassName={"page-item"} breakLinkClassName={"page-link"}
            activeClassName={"active"} forcePage={currentPage - 1} />
        </div>

        {/* Table */}
        {isLoading && <UserTableSkeleton />}
        {!isLoading && (
          <UserTable ref={componentRef_1} rows={currentData} userGroupMap={userGroupMap}
            emptyMessage="No users available" onEdit={getUserDetail} onDelete={isDeleteUser} />
        )}
      </div>

      {/* Alerts */}
      {issuccess && <Alert style={{ position: "absolute", right: "20px", top: "14px" }} variant="success"><p className="mb-0">User Details Successfully Updated</p></Alert>}
      {iserror && <Alert style={{ position: "absolute", right: "20px", top: "14px" }} variant="danger"><p className="mb-0">Something went wrong!! Please try after sometime</p></Alert>}
      {Deleteissuccess && <Alert style={{ position: "absolute", right: "20px", top: "14px" }} variant="success"><p className="mb-0">{deleteUserEmail} User Details Deleted Successfully</p></Alert>}

      {/* Edit Dialog */}
      {open && (
        <Dialog open={open} onClose={handleClose}>
          {UpdateisLoading ? (
            <><DialogTitle>Updating Details</DialogTitle><DialogContent><span>Please Wait...</span></DialogContent></>
          ) : (
            <>
              <DialogTitle style={{ background: "var(--app-button-color, #A70E13)", color: "#fff", fontWeight: "500" }}>Update Details</DialogTitle>
              <DialogContent style={{ marginTop: "16px" }}>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="validationCustom01">
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="email" value={EmailAdress} disabled style={{ cursor: "no-drop" }} />
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="validationCustom02">
                      <Form.Label>User Type *</Form.Label>
                      <Form.Select required value={UpdateuserType} onChange={(e) => setUpdateuserType(e.target.value)}>
                        <option value="Member">Member</option>
                        <option value="Admin">Admin</option>
                      </Form.Select>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="validationCustom03">
                      <Form.Label>User Group Name *</Form.Label>
                      <Select isMulti options={personaOptions} required value={selectedOptionsPersona} onChange={handleChangePersona} styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999
                                      })
                                    }}
                                    menuPosition={"fixed"}
/>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="validationCustom04">
                      <Form.Label>Roles *</Form.Label>
                      <Select options={roleOptions} required isMulti value={selectedOptions} onChange={handleChange} styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999
                                      })
                                    }}
                                    menuPosition={"fixed"}/>
                    </Form.Group>
                  </Row>
                  <div style={{ gridGap: "10px", display: "flex", marginTop: "2rem" }} className="mb-3">
                    <Button style={{ color: "white" }} className="submit_btn" type="submit">Update</Button>
                    <Button style={{ color: "white" }} onClick={resetForm} className="cancel_btn" type="reset">Reset</Button>
                    <Button style={{ color: "white" }} onClick={handleClose} className="cancel_btn">Close</Button>
                  </div>
                </Form>
              </DialogContent>
            </>
          )}
        </Dialog>
      )}

      {/* Delete Dialog */}
      {isDelete && (
        <Dialog open={isDelete} onClose={() => setisDelete(false)}>
          <DialogTitle>Are you sure you want to delete this user {deleteUserEmail}?</DialogTitle>
          <DialogContent>
            <DialogContentText>If you are certain about deleting this User, click "OK." Otherwise, click "Cancel."</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button className="cancel_btn" onClick={() => setisDelete(false)}>Cancel</Button>
            <Button className="submit_btn" style={{ color: "#fff" }} onClick={deleteusersinfo} autoFocus>Ok</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Deleting overlay */}
      {Deleteinguser && (
        <div style={{ position: "fixed", background: "rgba(0,0,0,0.8)", width: "100%", height: "100%", top: 0, left: 0, right: 0, bottom: 0, display: "grid", justifyContent: "center", alignItems: "center", color: "white", zIndex: 99999, justifyItems: "center", alignContent: "center" }}>
          <img width={200} src={preloadimg} alt="Loading" />
          <span>Deleting User Please wait...</span>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
